import React, { useState } from "react";

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted", formData);
    alert("Your message has been sent!");
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      phone: "",
      message: "",
    });
  };

  return (
    <>
    <div className="contactUs_container">
      <div className="contactUs_content">
        {/* Left Section */}
        <div className="contactUs_info">
        <img
            src="images/enquiry.png" // Replace with your image URL
            alt="Professional Person"
            className="canvaDesign_image"
          />
        </div>

        {/* Right Section */}
        <div className="contactUs_formWrapper">
          <form className="contactUs_form" onSubmit={handleSubmit}>
            <div className="contactUs_formRow">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
                className="contactUs_input"
              />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                required
                className="contactUs_input"
              />
            </div>
            <div className="contactUs_formRow">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
                className="contactUs_input"
              />
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Company Name"
                className="contactUs_input"
              />
            </div>
            <div className="contactUs_formRow">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                required
                className="contactUs_input"
              />
            </div>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows="4"
              required
              className="contactUs_textarea"
            ></textarea>
            <button type="submit" className="contactUs_button">
              Submit
            </button>
          </form>
        </div>
        
      </div>
      
    </div>
   <img
    src="images/contact.png" // Replace with your image URL
    alt="Professional Person"
    className="contact-img"
  />
  
  </>
  );
};

export default EnquiryForm;
